import Breadcrumbs_StylableComponentComponent from '../components/Breadcrumbs/viewer/skinComps/StylableComponent/StylableComponent.skin';
import Breadcrumbs_StylableComponentController from '../components/Breadcrumbs/viewer/Breadcrumbs.controller';


const Breadcrumbs_StylableComponent = {
  component: Breadcrumbs_StylableComponentComponent,
  controller: Breadcrumbs_StylableComponentController
};


export const components = {
  ['Breadcrumbs_StylableComponent']: Breadcrumbs_StylableComponent
};

